import type { FeatureStatusState } from "@/store/slices/featureStatus/featureStatus.types";

export const getDisabledFeaturesList = (
  featureStatus: FeatureStatusState | null
): string[] => {
  if (!featureStatus) {
    return [];
  }

  let disabledFeatures: string[] = [];

  Object.keys(featureStatus)?.forEach((feature: string) => {
    const keysOfFeature = Object.keys(featureStatus[feature]);

    const disabledSubFeatures = keysOfFeature
      .filter((featureState: string) => {
        return !(
          featureStatus[feature][featureState] ||
          featureStatus[feature]?.["enabled"]
        );
      })
      .map((feautreState) => `${feature}/${feautreState}`);

    if (disabledSubFeatures.length === keysOfFeature.length) {
      disabledFeatures.push(feature);
    }
    disabledFeatures = [...disabledFeatures, ...disabledSubFeatures];
  });

  return disabledFeatures;
};
